export default "__VITE_ASSET__d882840d__"